/*
 * How many lazily loaded pages are still on their way (utils/lazyPage.js).
 *
 * The boot splash (public/index.html, Components/SplashGate) owns the first
 * load of any URL and leaves when the business has resolved. A page that is
 * its own chunk has not even asked for the business while its chunk is in
 * flight, so without this count the splash would leave for a blank screen and
 * come back as a spinner. The route's Suspense fallback counts itself in while
 * it is mounted; the gate waits for zero.
 */
let pending = 0;
const listeners = new Set();

export function pendingPageCount() {
  return pending;
}

export function subscribePendingPage(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** A page's chunk is being fetched. Returns the call that says it arrived (or was given up on). */
export function pagePending() {
  pending += 1;
  listeners.forEach((listener) => listener());
  return () => {
    pending -= 1;
    listeners.forEach((listener) => listener());
  };
}
